import { CLEAR_ALT_TEXT, CLEAR_FILES, FILE_RECEIVED, FILE_UPLOAD_STATUS, SET_ALT_TEXT } from '@instructure/quiz-common';
export var clearAltText = function clearAltText() {
  return {
    type: CLEAR_ALT_TEXT
  };
};
export var clearFiles = function clearFiles() {
  return {
    type: CLEAR_FILES
  };
};
export var receiveFile = function receiveFile(file) {
  return {
    type: FILE_RECEIVED,
    payload: {
      file: file
    }
  };
};
export var setAltText = function setAltText(altText) {
  return {
    type: SET_ALT_TEXT,
    payload: {
      altText: altText
    }
  };
};
export var uploadStatus = function uploadStatus(status) {
  return {
    type: FILE_UPLOAD_STATUS,
    payload: {
      status: status
    }
  };
};